<template>
  <div class="retouching-repair-step-one">
    <v-switch
      v-model="form.idc_invoicing"
      hide-details
      label="Facturer"
      class="mb-4"
    />
    <v-textarea
      v-model="form.comments"
      filled
      name="Commentaires :"
      label="Commentaires :"
      height="calc(100vh - 56px - 86px - 60px - 150px)"
    />
  </div>
</template>

<script>
export default {
  name: "RetouchingRepairStepOne",
  props: {
    form: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
.retouching-repair-step-one {
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: 80px !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
  .v-input--selection-controls {
    margin-top: 0;
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
        h4 {
          font-size: 10px !important;
          &:first-child {
            color: #333;
            margin-right: 5px;
            font-size: 12px !important;
          }
        }
      }
    }
    .v-input__slot {
      align-items: flex-start;
      .v-label {
        align-items: baseline;
      }
    }
  }
}
</style>
